import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';
import { colors, typography } from '../../styles';


const styles = css`
  background-image: url('/images/trees.jpg');
  background-repeat:repeat-x;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  margin:0 auto;
  max-width: 1430px;
  padding:20px;
  @media (min-width: 768px) {
    margin:80px auto;
    background-position:center;
    background-size:auto;
    min-height:830px;
  }
  .Home_Testimonial {
    max-width: 700px;
    padding:20px;
    margin:60px auto;
    text-align:center;
    background-color:white;
    border:1px solid #eee;
    @media (min-width: 768px) {
      padding:60px;
    }
  }
  .Home_Testimonial_quote{
    font:italic 400 24px/36px ${typography.SansSerif};
    color:  ${colors.color5};
    margin-bottom:20px;
    @media (min-width: 768px) {
      font:italic 400 36px/54px ${typography.SansSerif};
      margin-bottom:40px;
    }
  }
  .Home_Testimonial_name {
    font:700 18px/1.4 ${typography.SansSerif};
    color:  ${colors.color1};
    letter-spacing: 2px;
    margin-top:20px;
    @media (min-width: 768px) {
      font:700 24px/1.4 ${typography.SansSerif};
      margin-top:40px;
    }
  }
`;

function HomeTestimonial({ page }) {
  return (
    <div className={styles}>
      <div className="Home_Testimonial">
        <div className="Home_Testimonial_quote">
          {page.home_testimonial[0].quote}
        </div>
        <img src="/images/dots.svg" alt="" />
        <div className="Home_Testimonial_name">
          {page.home_testimonial[0].name}
        </div>
      </div>
    </div>
  );
}

HomeTestimonial.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'home_page',
})(HomeTestimonial);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HomeTestimonial.js